import { FavouriteReplaceDomainNodes } from 'app/types-shared';

export const sortReplaceDomainNodes = (nodes: FavouriteReplaceDomainNodes[]): FavouriteReplaceDomainNodes[] =>
  [...nodes].sort((a, b) => (a.domainNode.d ?? '').localeCompare(b.domainNode.d ?? ''));
